import { toggleObjectTypeInMap } from '@store/debugger';

export const triggerObjectTypeInMap = () => {
    toggleObjectTypeInMap();
    window.location.reload();
};
